import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationGuard {
  constructor(
    private readonly _router: Router,
    private readonly _authenticationService: AuthenticationService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    // Get the permissions from the route data
    const permissions = route.data['PermissionPageName'];

    // Check if the user has at least one of the permissions
    const hasAccess = permissions.some((permission: any) =>
      this._authenticationService.checkAccess(permission),
    );

    if (hasAccess) {
      return true;
    } else {
      this._router.navigate(['/miscellaneous/error']);
      return false;
    }
  }
}
